import {geoPath, geoMercator} from 'd3-geo';
import { pointer } from 'd3-selection';

const d3 = {
	geoMercator,
	geoPath,
	pointer
}


import BaseChart from './base.chart';

// import './scss/index.scss'

let chartName = 'knd-map';

class Chart extends BaseChart {
	setup() {
		this.projection = d3.geoMercator();
		this.path = d3.geoPath()
	}

	draw() {
		this.drawSvg(chartName);
		this.drawContainer();
		this.setupPath();
	}

	drawContainer() {
		this.gContainer = this.g.append('g');

		this.gPaths = this.gContainer.append('g')
			.attr('class', 'g-path')
	} 

	updateScales() {
		this.projection
			.fitSize([this.width(), this.height()], this.data());

		this.path.projection(this.projection);
	}

	update() {
		this.updateScales();
		this.updateChart();
	}

	setupPath() {
		this.areas = this.gPaths.selectAll('path')
			.data(this.data().features)

		this.area = this.areas.join('path')
			.attr('class', d => this._className(d.properties));


		if(this.onMouseOver()) {
			let container = this.graphicContainer.node();
			this.area.on('mouseover', (event, d) => {
				const [mouseX, mouseY] = d3.pointer(event, container);

				this._onMouseOver({x: mouseX, y: mouseY}, d);
			})
		}

		if(this.onMouseOut()) {
			this.area.on('mouseout', d => {
				this._onMouseOut();
			})
		}

		return this;
	}

	select(selector) {
		let el = this.gPaths.select(selector);
		return el;
	}

	updateChart() {
		this.area
			.attr('d', this.path)
	}

	render() {
		this.setResponsive();

		this.setup();
		this.draw();
		this.update();

		return this;
	}

	resizeChart() {
		this.update();
	}

	onMouseOver(cb) {
		if (!arguments.length) return this._onMouseOver;
		this._onMouseOver = cb;
		return this;
	}

	onMouseOut(cb) {
		if (!arguments.length) return this._onMouseOut;
		this._onMouseOut = cb;
		return this;
	}	

	onClick(cb) {
		this.area.on("click", (event, d) => {
			cb(event, d);
		})
	}	
}

export default Chart;